// react
import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';

// third-party
import { Helmet } from 'react-helmet-async';
import Sections from '../home/Sections';

// data stubs
import ProgramContext from '../../contexts/ProgramContext';
import programApi from '../../server/real/endpoints/programs';

function TermsAndConditions(props) {
    const { program } = useContext(ProgramContext);
    const { locale, region } = props;
    const [page, setPage] = useState();
    useEffect(() => {
        if (!program) return;
        const content = programApi.getContent(program, locale);
        if (!content) return;
        const { pages } = content;
        if (!pages) return;
        const homePageData = pages.filter((data) => data.url === 'termsandconditions');
        if (homePageData.length === 0) return;
        setPage(homePageData[0]);
    }, [program, locale, region]);
    return (
        <div className="block">
            <ProgramContext.Consumer>
                {(context) => {
                    const { program } = context;
                    return (
                        <Helmet>
                            <title>{`Terms & Conditions— ${program.fullName}`}</title>
                        </Helmet>
                    );
                }}
            </ProgramContext.Consumer>

            <div className="container">

                {page && page.sections.length > 0 ? <Sections sections={page && page.sections} /> : (
                    <div className="document">
                        <div className="document__header">
                            <h1 className="document__title">Terms And Conditions</h1>
                            <div className="document__subtitle">This Agreement was last modified on 27 May 2018.</div>
                        </div>
                        <div className="document__content typography">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec facilisis neque ut purus fermentum, ac pretium nibh facilisis. Vivamus venenatis viverra iaculis. Suspendisse tempor orci non sapien ullamcorper dapibus. Suspendisse at velit diam. Donec pharetra nec enim blandit vulputate. Suspendisse potenti. Pellentesque et molestie ante. In feugiat ante vitae ultricies malesuada.</p>
                            <h2>Definitions</h2>
                            <ol>
                                <li>
                                    <strong>Risus</strong>
                                    — Morbi posuere eleifend sollicitudin. Praesent eget ante in enim scelerisque scelerisque. Donec mi lorem, molestie a sapien non, laoreet convallis felis. In semper felis in lacus venenatis, sit amet commodo leo interdum. Maecenas congue ut leo et auctor.
                                </li>
                                <li>
                                    <strong>Praesent</strong>
                                    — Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla orci ante, viverra in imperdiet in, pharetra et leo
                                </li>
                                <li>
                                    <strong>Vestibulum</strong>
                                    — Vestibulum arcu tellus, aliquam vel fermentum vestibulum, lacinia pulvinar ipsum. In hac habitasse platea dictumst. Integer felis libero, blandit scelerisque mauris eget, porta elementum sapien. Mauris luctus arcu non enim lobortis gravida.
                                </li>
                            </ol>
                            <h2>Ornare dolor</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec facilisis neque ut purus fermentum, ac pretium nibh facilisis. Vivamus venenatis viverra iaculis. Suspendisse tempor orci non sapien ullamcorper dapibus. Suspendisse at velit diam. Donec pharetra nec enim blandit vulputate. Suspendisse potenti. Pellentesque et molestie ante. In feugiat ante vitae ultricies malesuada.</p>
                            <p>
                                For information about how to contact us, please visit our
                                <a href="/">contact page</a>
                                .
                            </p>
                        </div>
                    </div>
)}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    region: state.region,
    locale: state.locale,
});

export default connect(mapStateToProps)(TermsAndConditions);
